import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Header({pageTitle, ...rest}) {
    
    const authUser = localStorage.getItem('FF-authUser');
    const user = JSON.parse(authUser);
    const navigate = useNavigate();
    const [isToggle, setIsToggle] = useState(false);
    const newRef = useRef(null);

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
          document.removeEventListener("mousedown", handleOutsideClick);
        };
    });
    
    const handleOutsideClick = (e) => {
        if (newRef.current && !newRef.current.contains(e.target)) {
            var user_profile_div = document.getElementById("user_profile");
            var dropdown_menu = document.getElementById("dropdown_menu");
            hideProfileBox(user_profile_div,dropdown_menu);
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    };

    const handleToggle = () => {
        var user_profile_div = document.getElementById("user_profile");
        var dropdown_menu = document.getElementById("dropdown_menu");
        if(isToggle === false){
            showProfileBox(user_profile_div,dropdown_menu);
        }
        else{
            hideProfileBox(user_profile_div,dropdown_menu);
        }
    }
    const showProfileBox = (user_profile_div,dropdown_menu) => {
        user_profile_div.classList.add('show');
            dropdown_menu.classList.add('show');
            user_profile_div.setAttribute('aria-expanded', 'true' );
            dropdown_menu.setAttribute('data-bs-popper', 'none' );            
            setIsToggle(true);

    }
    const hideProfileBox = (user_profile_div,dropdown_menu) => {
        user_profile_div.classList.remove('show');
        dropdown_menu.classList.remove('show');
        user_profile_div.setAttribute('aria-expanded', 'false' );
        dropdown_menu.removeAttribute('data-bs-popper');
        setIsToggle(false);        
    }

    return(
        <nav className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme" id="layout-navbar">
            <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 ">
                {/* <span className="nav-item nav-link px-0 me-xl-4" style={{cursor:'pointer'}}> */}
                {/* <span className="nav-item nav-link px-0 me-xl-4">
                    <i className="bx bx-menu bx-sm"></i>
                </span> */}
            </div>
            <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                
                <ul className="navbar-nav flex-row align-items-center ms-auto">                    
                    <li className="nav-item navbar-dropdown dropdown-user dropdown" ref={newRef}>
                        <a className="nav-link dropdown-toggle hide-arrow" data-bs-toggle="dropdown"  id="user_profile" onClick={handleToggle}>
                            <div className="avatar avatar-online">
                                <img src={user.image ? user.image : process.env.REACT_APP_BASE_URL+"assets/img/avatars/1.png"} alt="profile_avatar" className="w-px-30 rounded-circle"  style={{maxHeight:'30px',minHeight:'30px'}}/>
                            </div>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end" id="dropdown_menu">
                            <li>
                                <a className="dropdown-item" href="#">
                                    <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                            <div className="avatar avatar-online">
                                                <img src={user.image ? user.image : process.env.REACT_APP_BASE_URL+"assets/img/avatars/1.png"} alt="profile_avatar" className="w-px-30 rounded-circle" style={{maxHeight:'30px',minHeight:'30px'}}/>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <span className="fw-semibold d-block">{user.name}</span>
                                            <small className="text-muted">{user.role}</small>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <div className="dropdown-divider"></div>
                            </li>
                            <li>
                                <Link to="/profile" className="dropdown-item">
                                    <i className="bx bx-cog me-2"></i>
                                    <span className="align-middle me-2">Profile</span>
                                    {/* <span className="flex-shrink-0 badge badge-center rounded-pill bg-danger w-px-20 h-px-20">9</span> */}
                                </Link>
                            </li>
                            <li>
                                <div className="dropdown-divider"></div>
                            </li>
                            <li>
                                <span onClick={() => handleLogout()} className="dropdown-item" style={{cursor:'pointer'}}>
                                    <i className="bx bx-power-off me-2"></i>
                                    <span className="align-middle">Log Out</span>
                                </span>
                            </li>
                        </ul>
                    </li>                    
                </ul>
            </div>
        </nav>
    )
}